import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface BaseCardProps {
  title: string;
  reportLink: string;
  children: ReactNode;
  className?: string;
}

export function BaseCard({
  title,
  reportLink,
  children,
  className,
}: BaseCardProps) {
  return (
    <div
      className={cn(
        "flex min-h-[374px] flex-col rounded-lg border border-border bg-card p-6",
        className,
      )}
    >
      <h3 className="mb-4 text-xs font-semibold tracking-wider text-muted-foreground uppercase">
        {title}
      </h3>
      <div className="flex flex-1 flex-col gap-3">{children}</div>
      <div className="mt-auto border-t border-border pt-4 text-center">
        <a
          href={reportLink}
          className="text-xs font-normal text-muted-foreground transition-colors hover:text-primary"
        >
          View full report →
        </a>
      </div>
    </div>
  );
}
